export default __webpack_public_path__ + "static/media/DSC_0051.c4b82d7f.jpg";